import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { isSameDay, startOfMonth } from 'date-fns';
import Decimal from 'decimal.js';
import { utils } from '~/utils';
import { getLastXMonths } from '~/utils/date.utils';
import pluralize from '~/utils/pluralize';
import { fromDateStampObject } from './time';
export var SalesSummaryStatus = /*#__PURE__*/ function(SalesSummaryStatus) {
    SalesSummaryStatus["Sent"] = "sent";
    SalesSummaryStatus["Approved"] = "approved";
    SalesSummaryStatus["Terminated"] = "terminated";
    SalesSummaryStatus["Canceled"] = "canceled";
    SalesSummaryStatus["Reviewed"] = "reviewed";
    SalesSummaryStatus["Expired"] = "expired";
    return SalesSummaryStatus;
}({});
export class SalesSummaryModel {
    static fromDTO(dto, now) {
        const items = dto.calendar.map(SalesSummaryModel.itemFromDTO);
        return new SalesSummaryModel({
            numProposalsSentThisYear: new Decimal(dto.numProposalsSentThisYear),
            medianTimeToSign: new Decimal(dto.medianTimeToSign),
            calendar: fillLast12Months(items, now)
        });
    }
    static itemFromDTO(dto) {
        return {
            date: fromDateStampObject(dto.date),
            statuses: makeFullStatuses(dto.statuses)
        };
    }
    isEmpty() {
        return this.data.numProposalsSentThisYear.isZero();
    }
    formattedNumProposalsSentThisYear() {
        return utils.formatNumberWithCommas(this.data.numProposalsSentThisYear);
    }
    formattedMedianTimeToSign() {
        return this.isMedianTimeGreaterThanZero() ? pluralize('Day', this.data.medianTimeToSign.toDP(1).toNumber(), true) : 'Not available';
    }
    isMedianTimeGreaterThanZero() {
        return this.data.medianTimeToSign.greaterThan(0);
    }
    calendar() {
        return this.data.calendar;
    }
    constructor(data){
        _define_property(this, "data", void 0);
        this.data = data;
    }
}
function fillLast12Months(data, now) {
    return getLastXMonths(now, 12).map((date)=>{
        const asFirstOfMonth = startOfMonth(date);
        return data.find((item)=>isSameDay(asFirstOfMonth, startOfMonth(item.date))) || {
            date,
            statuses: makeFullStatuses({})
        };
    });
}
function makeFullStatuses(statuses) {
    return {
        ["sent"]: makeStatusValue(statuses["sent"]),
        ["approved"]: makeStatusValue(statuses["approved"]),
        ["terminated"]: makeStatusValue(statuses["terminated"]),
        ["canceled"]: makeStatusValue(statuses["canceled"]),
        ["reviewed"]: makeStatusValue(statuses["reviewed"]),
        ["expired"]: makeStatusValue(statuses["expired"])
    };
}
function makeStatusValue(dto) {
    return {
        total: new Decimal(dto ? dto.total : 0)
    };
}
